<template>
  <div
    class="text system"
    :class="{
      client: message.chatUserRole === 'Customer',
    }"
  >
    <div>
      <div
        class="content gpt-ql-editor"
        :class="{
          loading: message.id === 'loading',
        }"
      >
        <!--chatbot-->
        <div
          class="chatbot"
          v-if="message.chatUserRole === 'ChatBot'"
          :ref="message.id"
        ></div>
        <!--System-->
        <div v-else :ref="message.id"></div>
      </div>
      <!--滿意度-->
      <div
        class="options"
        v-if="message.chatUserRole === 'ChatBot' && typingCompleted"
      >
        <div>
          <i class="el-icon-loading" v-if="loading"></i>
          <div class="isLike" v-else>
            <div
              class="btn like"
              :class="{ active: message.isLike === true, disabled: isFinished }"
              @click="beforeChatLike(true)"
            >
              <i class="bx bx-like"></i>
            </div>
            <div
              class="btn dislike"
              :class="{
                active: message.isLike === false,
                disabled: isFinished,
              }"
              @click="beforeChatLike(false)"
            >
              <i class="bx bx-dislike"></i>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="time"
      :class="{ chatBot: message.chatUserRole === 'ChatBot' }"
      v-if="typingCompleted"
    >
      {{ message.createAt | localTime }}
    </div>
  </div>
</template>

<script>
import Typed from "typed.js";
export default {
  name: "gpt-message-system",
  data() {
    return {
      loading: false,
      typingCompleted: false,
    };
  },
  props: {
    message: {
      type: Object,
    },
  },
  mounted() {
    const chatUserRole = this.message.chatUserRole;
    let el;
    if (chatUserRole === "ChatBot") {
      let content = JSON.parse(this.message.content);
      el = `${content.ragResponse}<br />
      ${this.$t("GPT.LAYOUT.FOR_FURTHER")}
      <a href="${
        content.link
      }" target="_blank" class="kb-link" onclick="clickLink('${
        content.title
      }')">${content.title}</a>`;
    } else {
      el = this.message.content;
    }

    if (this.checkTyped(this.message.id) && this.message.id !== "loading") {
      this.$refs[this.message.id].insertAdjacentHTML("beforeend", el);
      this.typingCompleted = true;
    } else {
      this.startTying(el);
    }
  },
  methods: {
    startTying(el) {
      const vm = this;
      new Typed(this.$refs[this.message.id], {
        strings: [el],
        showCursor: false,
        typeSpeed: 10,
        loop: false,
        onComplete: function () {
          vm.setTyped(vm.message.id);
          vm.typingCompleted = true;
        },
      });
    },
    checkTyped(id) {
      let data = localStorage.getItem("asus_chat_gpt_typed") || [];
      return data.includes(id);
    },
    setTyped(id) {
      let data = JSON.parse(localStorage.getItem("asus_chat_gpt_typed")) || [];
      data.push(id);
      localStorage.setItem("asus_chat_gpt_typed", JSON.stringify(data));
    },
    beforeChatLike(val) {
      if (this.isFinished) {
        return;
      }
      if (val) {
        // like
        this.handleChatLike(true);
      } else {
        // dislike
        if (this.ChatGPT_IsShow_DislikeReason) {
          this.$bus.$emit("openBotSurvey", this.message.id);
        } else {
          this.handleChatLike(false);
        }
      }
    },
    async handleChatLike(val) {
      this.loading = true;
      try {
        await this.$store.dispatch("gpt/handleChatLike", {
          chatBotMessageId: this.message.id,
          likeFlag: val,
          surveyCode: "",
        });
        // GA4 按讚
        window.dataLayer.push({
          event: "data_layer_event",
          chatbot_session_id: this.chatbot_session_id,
          event_name_ga4: val ? "like_genio" : "dislike_genio",
          event_category_DL: "genio",
          event_action_DL: "clicked",
          event_label_DL: val ? "like" : "dislike",
        });
      } catch (error) {
        console.log("error", error);
      }
      this.loading = false;
    },
  },
  computed: {
    isFinished() {
      return this.$store.state.gpt.botRoom.isFinished;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "gpt.scss";
</style>
